module.exports = __webpack_public_path__ + "img/ambassadors-header-color.28bd5a91.svg";